import * as React from 'react';
import * as Yup from 'yup';

import { Button, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import StripeCheckout, { Token } from 'react-stripe-checkout';

import { DialogStatus } from 'common/components/dialogs/DialogStatus';
import { FormMoneyInput } from 'common/components/form/FormMoneyInput';
import { Formik, FormikProps } from 'formik';
import { TransactionApi } from 'common/api/resources/TransactionApi';
import { formatMoneyValue } from 'common/utils/format';
import { toApiError } from 'common/utils/api';
import { toFormGroupStyle } from 'common/utils/form';
import { Analytics } from 'common/utils/Analytics';
import { MemberApi } from 'common/api/resources/MemberApi';
import { Member } from 'common/api/models/Member';

interface ChargeDialogProps {
  isOpen: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  accountId: string;
  orderId: string;
  chargeAmount: number;
}
interface ChargeDialogState {
  amount: number;
  autorenew: boolean;
  isLoading?: boolean;
  error?: string;
}
interface ChargeValues {
  amount: string;
  autorenew: boolean;
}

export class ChargeDialog extends React.Component<ChargeDialogProps, ChargeDialogState> {
  state: ChargeDialogState = { amount: 0, autorenew: false };

  validationSchema = Yup.object().shape({
    amount: Yup.number().required('Required'),
  });

  initialValues() {
    return {
      amount: formatMoneyValue(this.props.chargeAmount),
      autorenew: false,
    };
  }

  handleCheckout = (e: React.MouseEvent<any>) => {
    e.preventDefault();
  };

  handleStripeToken = (token: Token) => {
    this.setState({ isLoading: true });
    const amount = this.state.amount;
    TransactionApi.processCharge({
      accountId: this.props.accountId,
      orderId: this.props.orderId,
      token: token.id,
      amount,
      updateStripeCustomer: this.state.autorenew,
    }).then(
      res => {
        // set renewType to AUTO if autorenew button is checked
        const update: Promise<any> = this.state.autorenew
          ? MemberApi.updateMember(this.props.accountId, { renewType: Member.RenewType.AUTO })
          : Promise.resolve();
        update.then(
          result => {
            Analytics.order.payment();
            this.setState({ isLoading: false, error: undefined });
            this.props.onSubmit();
          },
          err => {
            this.setState({ isLoading: false, error: toApiError(err) });
          }
        );
      },
      err => {
        this.setState({ isLoading: false, error: toApiError(err) });
      }
    );
  };

  handleSubmit = (values: ChargeValues) => {
    this.setState({ amount: this.toNumber(values.amount), autorenew: values.autorenew });
  };

  toNumber(num: string): number {
    return Number(num.replace(/,/g, ''));
  }

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<ChargeValues>) => (
            <form onSubmit={form.handleSubmit} data-testid="chargeDialogForm">
              <ModalHeader toggle={this.props.onCancel}>Charge Credit Card</ModalHeader>
              <ModalBody>
                <FormMoneyInput id="amount" name="amount" label="Charge Amount" />
                <FormGroup color={toFormGroupStyle('autorenew', form)}>
                  <label>
                    <input
                      type="checkbox"
                      id="autorenew"
                      checked={form.values.autorenew}
                      onChange={form.handleChange}
                    />{' '}
                    Auto-Renew
                  </label>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <StripeCheckout
                    name="Charge Credit Card"
                    email="cloud@nkba.org"
                    currency="USD"
                    amount={this.toNumber(form.values.amount) * 100}
                    token={this.handleStripeToken}
                    stripeKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY!}
                    allowRememberMe={false}
                  >
                    <button className="btn btn-primary" data-testid="chargeDialogFormSubmit">
                      <i className="fa fa-credit-card" /> Charge
                    </button>
                  </StripeCheckout>
                </div>
              </ModalFooter>
              <DialogStatus error={this.state.error} isLoading={this.state.isLoading} />
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/ChargeDialog.tsx